import React from 'react';
import { EyeIcon, ArrowRightIcon, SparklesIcon, ImageIcon, LightbulbIcon, FileTextIcon, UsersIcon } from 'lucide-react';
export const KeyInsights: React.FC = () => {
  return <div className="space-y-8 bg-white p-8 rounded-sm shadow-[0_2px_8px_rgba(0,0,0,0.05)] border border-[#E5E5E5]" data-id="element-254">
      {/* Key Insights Section */}
      <div className="w-full" data-id="element-255">
        <div className="flex items-center space-x-3 mb-6" data-id="element-256">
          <LightbulbIcon className="h-6 w-6 text-[#C00000]" data-id="element-257" />
          <h3 className="text-xl font-semibold text-[#101010]" data-id="element-258">Key Insights</h3>
        </div>
        <ul className="text-[#404040] leading-relaxed space-y-4 list-disc pl-5" data-id="element-259">
          <li data-id="element-260">
            Creative choice is an audience decision, not only a design decision.
            The same four creatives produced two different winners depending on
            the segment.
          </li>
          <li data-id="element-261">
            Within the tech enthusiast segment, product-led creative generated
            significantly more behavioural interaction than lifestyle-led
            creative in this illustrative example.
          </li>
          <li data-id="element-262">
            Product-led creative held acceptable mid-table performance within
            the lifestyle segment, making it the stronger cross-segment choice
            in this example.
          </li>
        </ul>
      </div>
      {/* Recommendations Section */}
      <div className="mt-12" data-id="element-263">
        <div className="flex items-center space-x-3 mb-8" data-id="element-264">
          <SparklesIcon className="h-6 w-6 text-[#C00000]" data-id="element-265" />
          <h3 className="text-xl font-semibold text-[#101010]" data-id="element-266">
            Recommendations & Next Steps
          </h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-267">
          {/* Validate with your own assets */}
          <div className="bg-[#C00000]/5 p-6 rounded-sm border border-[#C00000]/10 hover:shadow-[0_4px_12px_rgba(0,0,0,0.05)] transition-shadow" data-id="element-268">
            <div className="flex items-center space-x-3 mb-4" data-id="element-269">
              <div className="p-2 bg-[#C00000]/10 rounded-sm" data-id="element-270">
                <ArrowRightIcon className="h-5 w-5 text-[#C00000]" data-id="element-271" />
              </div>
              <h4 className="font-medium text-[#101010]" data-id="element-272">
                Validate with your own assets
              </h4>
            </div>
            <div className="space-y-3 text-sm text-[#404040] leading-relaxed" data-id="element-273">
              <p data-id="element-274">
                Replace these fictional variants with the actual global and EMEA
                creatives to turn this example into evidence.
              </p>
            </div>
          </div>
          {/* Define the segments together */}
          <div className="bg-[#C00000]/5 p-6 rounded-sm border border-[#C00000]/10 hover:shadow-[0_4px_12px_rgba(0,0,0,0.05)] transition-shadow" data-id="element-275">
            <div className="flex items-center space-x-3 mb-4" data-id="element-276">
              <div className="p-2 bg-[#C00000]/10 rounded-sm" data-id="element-277">
                <UsersIcon className="h-5 w-5 text-[#C00000]" data-id="element-278" />
              </div>
              <h4 className="font-medium text-[#101010]" data-id="element-279">
                Define the segments together
              </h4>
            </div>
            <div className="space-y-3 text-sm text-[#404040] leading-relaxed" data-id="element-280">
              <p data-id="element-281">
                We refine the tech enthusiast and lifestyle audience definitions
                around your buyer profiles before the test starts.
              </p>
            </div>
          </div>
          {/* Evidence in 5 to 7 days */}
          <div className="bg-[#C00000]/5 p-6 rounded-sm border border-[#C00000]/10 hover:shadow-[0_4px_12px_rgba(0,0,0,0.05)] transition-shadow" data-id="element-282">
            <div className="flex items-center space-x-3 mb-4" data-id="element-283">
              <div className="p-2 bg-[#C00000]/10 rounded-sm" data-id="element-284">
                <FileTextIcon className="h-5 w-5 text-[#C00000]" data-id="element-285" />
              </div>
              <h4 className="font-medium text-[#101010]" data-id="element-286">
                Evidence in 5 to 7 days
              </h4>
            </div>
            <div className="space-y-3 text-sm text-[#404040] leading-relaxed" data-id="element-287">
              <p data-id="element-288">
                Evidence in 5 to 7 days after test start, statistically tested
                per segment and between segments, ready to present internally.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};